<template>
	<div class="exhibition">
		<surround-image v-if="isShowSurround"></surround-image>

	</div>
</template>

<script>
	import HotContent from '@/views/exhibition/childrenComponents/hotContent.vue'
	import SurroundImage from '@/views/exhibition/childrenComponents/surroundImage.vue'
	import ImageTextContent from '@/views/exhibition/childrenComponents/imageTextContent.vue'
	import PictureList from '@/views/exhibition/childrenComponents/PictureList.vue'
	import {Decrypt,Encrypt} from '@/common/secret.js'
	export default {
		data(){
			return {
				isShowHall:false,
				isShowSurround:true,
				isShowHotContent:false,
				isShowPictureList:false
			}
		},
		components:{
			ImageTextContent,
			SurroundImage,
			HotContent,
			PictureList
		},
		mounted() {
			if(this.$route.query.roomId != undefined ) {
				
				this.$store.commit('updataHallId',Decrypt(this.$route.query.roomId))
				this.isShowHall = true
			}else if(this.$route.query.hotId != undefined ){
				this.$store.commit('updataHotId',this.$route.query.hotId)
				this.isShowHotContent = true
			}
			// 在当前组件中获取url中的id ，并对值进行判断，选择渲染哪个组件
			// 如果是hotId，对传过来的type进行判断，图文--显示图文，环物--显示环物，图集--显示图集

		},
		methods:{
			
		},
		
		
	}
</script>

<style scoped="scoped">
	.surround-image {

	}
</style>
